import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { courseGetFlrstInfo, courseGetFlrstExamResults } from 'dsoapi';

const CoursePageFloridaRoadSign = () => {
  const { userCourseEnrollmentId } = useParams();
  const [webTestUrl, setWebTestUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [passedCourse, setPassedCourse] = useState('');
  const [status, setStatus] = useState('');
  const [examResults, setExamResults] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const getPassedCourseLabel = (code) => {
    switch (code) {
      case 'Y':
        return 'Yes';
      case 'N':
        return 'No';
      case 'I':
        return 'In Progress';
      case 'P':
        return 'Passed';
      case 'F':
        return 'Failed';
      default:
        return code || 'N/A';
    }
  };

  useEffect(() => {
    const fetchFlrstInfo = async () => {
      setLoading(true);
      setError('');
      setDataLoaded(false);

      try {
        console.log('Fetching FLRST info...');
        const resp = await courseGetFlrstInfo(userCourseEnrollmentId);
        const flrstInfo = resp?.data?.fedsUserFlrstInfo;
        console.log('Full flrstInfo object:', flrstInfo);

        if (!flrstInfo) {
          throw new Error('No FLRST info received');
        }

        // Extract WebTestURL from exams JSON field
        let url = '';
        const exams = flrstInfo?.exams;
        try {
          const examsObj =
            typeof exams === 'string' ? JSON.parse(exams) : exams;
          url = examsObj?.TestAuthorizationResponse?.WebTestURL || '';
        } catch (err) {
          console.error('Error parsing exams:', err);
          url = '';
        }

        // Set the URL first
        setWebTestUrl(url);

        // Always call exam results API to get the latest status
        console.log(
          'Calling courseGetFlrstExamResults to get current status...'
        );
        try {
          const examResp = await courseGetFlrstExamResults(
            userCourseEnrollmentId
          );
          console.log('Received exam results:', examResp?.data);

          const examResults = examResp?.data;
          setExamResults(examResults);

          // Extract status and passFailFlag from exam results
          const examHistory = examResults?.examResultResponse?.examHistory;
          if (examHistory && examHistory.length > 0) {
            const latestExam = examHistory[0]; // Get the most recent exam
            const passFailFlag = latestExam?.passFailFlag || '';
            const userStatus = latestExam?.status || '';

            console.log(
              'Extracted from exam results - passFailFlag:',
              passFailFlag,
              'status:',
              userStatus
            );

            setPassedCourse(passFailFlag);
            setStatus(userStatus);
          } else {
            console.log('No exam history found in results');
            setPassedCourse('');
            setStatus('');
          }
        } catch (examErr) {
          console.error('Failed to load exam results:', examErr);
          setExamResults(null);
          setPassedCourse('');
          setStatus('');
        }

        // Mark data as loaded
        setDataLoaded(true);
        setLoading(false);
      } catch (e) {
        console.error('Error loading FLRST info:', e);
        setError('Error loading FLRST info');
        setLoading(false);
        setDataLoaded(false);
      }
    };

    fetchFlrstInfo();
  }, [userCourseEnrollmentId]);

  if (loading) {
    return (
      <div className="ui container" style={{ marginTop: '2em' }}>
        <div className="ui active centered inline loader"></div>
        <p style={{ textAlign: 'center', marginTop: '1em' }}>
          Loading exam information...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ui container" style={{ marginTop: '2em' }}>
        <div className="ui error message">
          <div className="header">Error Loading Data</div>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!dataLoaded) {
    return (
      <div className="ui container" style={{ marginTop: '2em' }}>
        <div className="ui warning message">
          <div className="header">Data Not Available</div>
          <p>Exam data is not available. Please try refreshing the page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ui container" style={{ marginTop: '2em' }}>
      <h2>Florida Road and Sign Test</h2>

      <div className="ui segment">
        <p>
          <strong>Status:</strong> {status || 'N/A'}
        </p>
        <p>
          <strong>Passed Course:</strong> {getPassedCourseLabel(passedCourse)}
        </p>
      </div>

      {examResults && (
        <div style={{ marginTop: '1em' }}>
          <h4>Exam Results (just putting this information here for now)</h4>
          <pre>{JSON.stringify(examResults, null, 2)}</pre>
        </div>
      )}

      {passedCourse === 'P' && (
        <div
          style={{
            margin: '1em 0',
            padding: '1em',
            backgroundColor: '#e6ffe6',
            border: '1px solid #b2ffb2',
            borderRadius: '6px',
          }}
        >
          🎉 <strong>Congratulations!</strong> You passed the Florida Road and
          Sign Test.
        </div>
      )}

      {webTestUrl ? (
        <div className="ui segment">
          <p>
            <strong>Web Test URL:</strong>{' '}
            <a href={webTestUrl} target="_blank" rel="noopener noreferrer">
              {webTestUrl}
            </a>
          </p>
        </div>
      ) : (
        <div className="ui warning message">
          <p>No web test URL available.</p>
        </div>
      )}
    </div>
  );
};

export default CoursePageFloridaRoadSign;
